// extracted by mini-css-extract-plugin
export default {"Comment":"styles_Comment__F+CGZ","Comment__box":"styles_Comment__box__gThgw","Comment__boxGreen":"styles_Comment__boxGreen__UkA6T"};